import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../services/apiClient";

export interface ForecastTuningPolicyEntry {
  id: string;
  key: string;
  value_numeric: number | null;
  value_text: string | null;
  value_json: unknown;
  description: string;
  category: string;
  unit: string | null;
  min_value: number | null;
  max_value: number | null;
  updated_at: string;
  updated_by: string | null;
}

const QUERY_KEY = ["forecast-tuning-policy"] as const;

export function useForecastTuningPolicies() {
  return useQuery<ForecastTuningPolicyEntry[]>({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const res = await apiClient.get<ForecastTuningPolicyEntry[]>(
        "/forecast-tuning-policy",
      );
      return res.data;
    },
    staleTime: 60_000,
  });
}

export function useUpdateForecastTuningPolicy() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: {
      key: string;
      value_numeric?: number | null;
      value_text?: string | null;
    }) => {
      const { key, ...body } = input;
      const res = await apiClient.put<ForecastTuningPolicyEntry>(
        `/forecast-tuning-policy/${encodeURIComponent(key)}`,
        body,
      );
      return res.data;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
